export const RESET_VARIABLE = "RESET_VARIABLE";
export const GET_VARIABLE = "GET_VARIABLE";
export const SET_VARIABLE = "SET_VARIABLE";
export const API_ERROR_VARIABLE = "API_ERROR_VARIABLE";